/*
 * FarmSteady — recipe kit footer visibility controller.
 *
 * Companion to snippets/fs-recipe-kit-footer.liquid. Same motion language
 * as the PDP sticky ATC (farmsteady-sticky-atc.js) but article-specific
 * logic:
 *
 *   SHOW  once the article header (.fs-article__header) has scrolled off
 *         the top edge — the reader is into the content.
 *   HIDE  permanently once the inline kit card (.fs-kit-cta) enters the
 *         viewport — the reader reached the full-size card; showing both
 *         would be redundant. (The card sits at the article's end, so in
 *         practice the bar accompanies the whole read.)
 */

(function () {
  'use strict';

  function init() {
    const bar = document.querySelector('[data-fs-recipe-footer]');
    if (!bar || !('IntersectionObserver' in window)) return;

    const header = document.querySelector('.fs-article__header');
    if (!header) return;

    bar.hidden = false;
    let retired = false;

    const headerObserver = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (retired) return;
        // Same "left via the top edge" rule as the PDP chip — prevents the
        // bar from appearing instantly on load when the header is below
        // the fold or the page opens mid-scroll.
        if (!entry.isIntersecting && entry.boundingClientRect.bottom < 0) {
          bar.dataset.visible = 'true';
        } else {
          bar.dataset.visible = 'false';
        }
      },
      { threshold: 0 }
    );
    headerObserver.observe(header);

    const card = document.querySelector('.fs-kit-cta');
    if (card) {
      const cardObserver = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            retired = true;
            bar.dataset.visible = 'false';
            cardObserver.disconnect();
            headerObserver.disconnect();
          }
        },
        { threshold: 0.4 }
      );
      cardObserver.observe(card);
    }
  }

  if (['interactive', 'complete'].includes(document.readyState)) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
